import {
  CheckoutTab,
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import CurrentCheckoutTab from "pages/checkout/tabs";
import { Fragment } from "react";
import CompletedStepIcon from "shared/ui/icons/checkout/CompletedStepIcon";
import CurrentStepIcon from "shared/ui/icons/checkout/CurrentStepIcon";
import PendingStepIcon from "shared/ui/icons/checkout/PendingStepIcon";
import { twMerge } from "tailwind-merge";

const CheckoutMobileSteps = () => {
  const {
    currentTab,
    updateCurrentTab,
    checkoutTabs,
    visitedTabs,
    disabledTabs,
  } = useCheckoutTabsContext();

  const onStepClick = (tab: CheckoutTab) => {
    if (!visitedTabs.includes(tab.id)) return;
    if (disabledTabs.includes(tab.id)) return;
    if (currentTab.id === tab.id) return;

    updateCurrentTab(tab.id);
  };

  if (currentTab.id === CheckoutTabIds.NO_PRODUCTS)
    return <CurrentCheckoutTab />;
  if (currentTab.hideNavbar) return <></>;
  return (
    <nav className={"md:gg-py-11"}>
      <ul className="gg-divide-y">
        {checkoutTabs.map((tab: CheckoutTab, index: number) => {
          if (tab.hidden) return null;

          const isActive = tab.title === currentTab.title;
          const isCompleted = visitedTabs.includes(
            checkoutTabs[index + 1 < checkoutTabs.length ? index + 1 : index]
              .id,
          );

          return (
            <Fragment key={tab.id}>
              <li
                className={twMerge(
                  "gg-bg-grey-300",
                  isActive ? "gg-font-bold" : "gg-text-grey-100",
                )}
              >
                <button
                  className="gg-flex gg-w-full gg-items-center gg-gap-1 gg-px-3.5 gg-py-4 gg-text-left"
                  onClick={() => onStepClick(tab)}
                >
                  {isActive ? (
                    <CurrentStepIcon />
                  ) : isCompleted ? (
                    <CompletedStepIcon />
                  ) : (
                    <PendingStepIcon />
                  )}
                  {tab.title}
                </button>
              </li>

              {isActive && <CurrentCheckoutTab />}
            </Fragment>
          );
        })}
      </ul>
    </nav>
  );
};
export default CheckoutMobileSteps;
